export class MaxLengthConstants {
  static readonly pazMatchingAnswersMaxLength = 26;
  static readonly rangeCorrectAnswerMaxLength = 16;
  static readonly rangeAnswerWithCommasMaxLength = 21;
  static readonly chooseTenAnswersMaxLength = 25;
}
